export default __webpack_public_path__ + "d41c2fa8c9d33c55f45cc80e91737ea7.png";